module.exports = __webpack_public_path__ + "static/checkmark-dff9576c3353f6b115ca7ea606e112a4.png";